import { render, staticRenderFns } from "./ArchiveDashboard.vue?vue&type=template&id=62e21277&"
import script from "./ArchiveDashboard.vue?vue&type=script&lang=js&"
export * from "./ArchiveDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports